var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bottom-dialog',{attrs:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event)}}},[_c('chat-face-select',{attrs:{"faces":_vm.faces,"value":_vm.face},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }